import script from "./login-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./login-form.vue?vue&type=script&lang=ts&setup=true"

import "./login-form.vue?vue&type=style&index=0&id=791ab0e1&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-791ab0e1"]])

export default __exports__